<template>
  <q-card class="no-padding bg-white no-scroll full-height">
    <q-card-main class="row full-height no-padding">
      <div class="col-12 dash-number-box dash-number-box-padding">
        <h2 class="dash-number-box__heading--bold">{{ $t('statistics_project_hours') }}</h2>
        <h3 class="dash-number-box__sub-heading">
          {{ $t('statistics_project_hours_month') }}
        </h3>
      </div>

      <project-seconds-statistics-donut-chart
        v-if="hasData"
        :projectSecondsStatisticsData="data"
        :options="chartOptions"
        class="col-12 justify-center q-pa-lg"
        :height="300"
      />

      <template v-else>
        <div class="col-12 text-center q-pb-lg">
          <span class="q-title text-blue-grey-4">{{ $t('statistics_project_hours_no_data') }}</span>
        </div>
      </template>
    </q-card-main>
  </q-card>
</template>

<script>
  import ProjectSecondsStatisticsDonutChart from 'components/TimeTracking/ProjectSecondsStatisticsDonutChart.vue'

  export default {
    props: {
      data: {
        required: true,
        type: Array
      }
    },

    computed: {
      hasData () {
        return this.data.length > 0 &&
          this.entriesWithMoreThanZeroHours.length > 0
      },

      entriesWithMoreThanZeroHours () {
        return this.data.filter(project => Math.round(project.value / (60 * 60) > 0))
      },

      chartOptions () {
        return {
          legend: {
            position: 'left'
          }
        }
      }
    },

    components: {
      ProjectSecondsStatisticsDonutChart
    }
  }
</script>
